import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import AboutUs from './pages/about/AboutPage';
import Departments from './pages/departments/DepartmentsPage';
import AppliedBehavioralAnalysis from './pages/departments/DepartmentsPage';
import SpeechLanguagePathologyPage from './pages/departments/SpeechLanguagePathologyPage';
import OccupationalTherapyPage from './pages/departments/OccupationalTherapyPage';
import SpecialEducationPage from './pages/departments/SpecialEducationPage';
import ProgramsPage from './pages/programs/ProgramsPage';
import SchoolReadinessProgramPage from './pages/programs/SchoolReadinessProgramPage';
import ParentCoachingProgramPage from './pages/programs/ParentCoachingProgramPage';
import HomeBasedLearningSupportProgramPage from './pages/programs/HomeBasedLearningSupportProgramPage';
import GroupAndSocialSkillsProgramPage from './pages/programs/GroupAndSocialSkillsProgramPage';
import OurTeamPage from './pages/teams/OurTeamPage';
import BlogsPage from './pages/blogs/BlogsPage';
import BlogsPageDetails from './pages/blogs/BlogPageDetails';
import EventsPage from './pages/events/EventsPage';
import EventPageDetails from './pages/events/EventPageDetails';
import AchievementsPage from './pages/achievements/AchievementsPage';
import TestimonialsPage from './pages/testimonials/TestimonialsPage';
import FaqPage from './pages/faq/FaqPage';
import GalleryPage from './pages/gallery/GalleryPage';
import Contact from './pages/contact';
import RHCAHosur from './pages/rhcahosur';
import RHCAElectronic from './pages/rhcaelectronic';
import TermsandCondition from './pages/TermsandConditions';

import Header from './layout/header';
import Footer from './layout/footer';
import NotFoundPage from './pages/404';


function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/applied-behavioral-analysis" element={<AppliedBehavioralAnalysis />} />
        <Route path="/speech-language-pathology" element={<SpeechLanguagePathologyPage />} />
        <Route path="/occupational-therapy" element={<OccupationalTherapyPage />} />
        <Route path="/special-eduaction" element={<SpecialEducationPage />} />
        <Route path="/early-intervention-program" element={<ProgramsPage />} />
        <Route path="/school-readiness-program" element={<SchoolReadinessProgramPage />} />
        <Route path="/caregiver-coaching-program" element={<ParentCoachingProgramPage />} />
        <Route path="/parent-counselling-program" element={<HomeBasedLearningSupportProgramPage />} />
        <Route path="/group-and-social-skills-program" element={<GroupAndSocialSkillsProgramPage />} />
        <Route path="/our-team" element={<OurTeamPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog-details/:id" element={<BlogsPageDetails />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/event-details/:id" element={<EventPageDetails />} />
        <Route path="/achievements" element={<AchievementsPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/RHCA-hosur" element={<RHCAHosur />} />
        <Route path="/RHCA-electronic-city" element={<RHCAElectronic />} />
        <Route path="/terms-and-conditions" element={<TermsandCondition />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
